import type { LineStringObject, PointOnLineStringObject } from '@racemap/utilities/types/geos';
import type { LineStringCoordinate } from '../DirectSelectMode';

export function getNewCoordinateIndex(
  point: PointOnLineStringObject,
  lineString: LineStringObject,
  coordinates: Array<LineStringCoordinate>,
  coordinateAction: 'add' | 'delete',
): null | number {
  const maxIndex = lineString.geometry.coordinates.length - 1;
  const minIndex = 0;
  const currentIndex = point.properties.coordinateIndex;

  let newIndex = currentIndex;
  for (const coordinate of coordinates) {
    if (currentIndex < coordinate.index) return currentIndex;

    switch (coordinateAction) {
      case 'add':
        newIndex = Math.min(maxIndex, currentIndex + 1);
        break;
      case 'delete':
        newIndex = Math.max(minIndex, currentIndex - 1);
        break;
    }
  }

  return newIndex;
}
